import React from "react";
import { Button } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";

import DefaultTable from "../components/table";
import DynamicSnackbar from "../components/dynamic_snackbar";
import LoadingBackdrop from "../components/loading_backdrop";
import issueStateUpdateRequest from "../components/panel_update_helper";

class SearchPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      dynamicSnackbar: {
        open: false,
        severity: null,
        message: null,
        url: null,
      },
      searchProperties: [],
      searchPropertiesValues: {},
      searchResults: {
        headers: [],
        values: [],
        urls: [],
      },
    };
  }

  render() {
    return (
      <div className="panel server-panel">
        <LoadingBackdrop open={this.state.loading} />
        <DynamicSnackbar
          open={this.state.dynamicSnackbar.open}
          severity={this.state.dynamicSnackbar.severity}
          message={this.state.dynamicSnackbar.message}
          url={this.state.dynamicSnackbar.url}
          handleClose={() => {
            this.setState({
              dynamicSnackbar: { ...this.state.dynamicSnackbar, open: false },
            });
          }}
        />
        <h1>Search</h1>
        <div
          className="panel-section"
          style={{ display: "flex", flexWrap: "wrap" }}
        >
          {this.state.searchProperties.map(this.renderSearchParameter)}
        </div>
        <div className="panel-section">
          <Button
            variant="contained"
            color="primary"
            onClick={this.handleSearchButtonClick}
          >
            <SearchIcon />
            Search
          </Button>
        </div>
        <div className="panel-section">
          <DefaultTable
            tableHeaders={this.state.searchResults.headers}
            tableRows={this.state.searchResults.values}
            tableUrls={this.state.searchResults.urls}
          />
        </div>
      </div>
    );
  }

  renderSearchParameter = (parameterProps) => {
    return (
      <TextField
        style={{ margin: "5px", flex: "0 1 300px" }}
        key={parameterProps.id}
        variant="outlined"
        className="textfield"
        component={Paper}
        elevation={1}
        {...parameterProps}
        onChange={(event) =>
          this.handleSearchParameterChange(
            parameterProps.id,
            event.target.value
          )
        }
        onKeyDown={(event) => this.handleSearchParameterKeyDown(event.key)}
        InputLabelProps={{
          shrink: true,
        }}
      />
    );
  };

  handleSearchParameterChange = (parameter, value) => {
    let newValues = { ...this.state.searchPropertiesValues };
    newValues[parameter] = value;
    this.setState({ searchPropertiesValues: newValues });
  };

  handleSearchParameterKeyDown = (keyPressed) => {
    if (keyPressed === "Enter") this.handleSearchButtonClick();
  };

  async componentDidMount() {
    await issueStateUpdateRequest(this, "/search_panel/properties");
  }

  handleSearchButtonClick = async () => {
    await issueStateUpdateRequest(
      this,
      "/search_panel/search",
      this.state.searchPropertiesValues,
      "post"
    );
  };
}

export default SearchPanel;
